import styled from "styled-components";
import { SPACING, QUERIES } from "../../utils/constants";
import { NotificationWrapper } from "../Notification/styles";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary-color-background);
  padding: ${SPACING.md + SPACING.xs}px;

  @media (max-width: 600px) {
    padding: ${SPACING.md}px;
  }
`;

export const Wrapper = styled.div`
  min-height: 100vh;
  background: var(--color-background-0);
`;

export const MainWrapper = styled.div`
  height: 100vh;
  overflow-y: auto;
  background: var(--color-background-0);
  color: var(--color-text-default);

  /* account for fixed top navbar on desktop */
  @media ${QUERIES.tabletLargeAndUp} {
    padding-top: ${SPACING.xxl + SPACING.xs}px;
  }

  /* account for fixed bottom nav on mobile */
  @media ${QUERIES.tabletLargeAndDown} {
    padding-bottom: calc(
      ${SPACING.xxl + SPACING.md}px + env(safe-area-inset-bottom, 0px)
    );
  }
`;

export const NotificationWrapperOver = styled(NotificationWrapper)`
  top: 4%;
  right: 4%;
`;
